import types from '../types';

const videos = (state = { loading: true, data: null }, { type, payload }) => {
  switch (type) {
    case types.GET_VIDEOS_START:
      return { ...state, loading: true };

    case types.GET_VIDEOS_SUCCESS:
      return { data: payload, loading: false };

    case types.GET_VIDEOS_FAILURE:
      return { ...state, loading: false };

    case types.CREATE_VIDEOS_SUCCESS:
      return { data: [...state.data, payload], loading: false };

    case types.DELETE_VIDEOS_SUCCESS:
      return {
        data: state.data.filter(video => video.id !== payload),
        loading: false,
      };

    default:
      return state;
  }
};

export default videos;
